export default class NumberUtils {
    static parseNumber(number: string): number {
        return Number.parseInt(number, 10);
    }

    static isPositiveInteger(number: any): boolean {
        return number >>> 0 === parseFloat(number)
    }
}